<template>
  <div>
    <div class="flex animate-pulse space-x-4">
      <div class="flex flex-1 items-center px-4 py-4 sm:px-6">
        <div class="flex min-w-0 flex-1 items-center">
          <div class="flex-1 px-4 md:grid md:grid-cols-2 md:gap-4">
            <div>
              <div class="pr-8 text-sm font-medium text-neutral-800 lg:pr-16">
                <div class="h-2 rounded bg-neutral-300"></div>
              </div>
              <div class="mt-2 pr-8 text-sm text-neutral-500 lg:pr-16">
                <div class="h-2 rounded bg-neutral-200"></div>
              </div>
            </div>
            <div class="hidden justify-center md:flex md:flex-col">
              <div class="pr-8 text-sm text-neutral-900 lg:pr-16">
                <div class="h-2 rounded bg-neutral-300"></div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="h-6 w-6 rounded bg-neutral-200"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

/** A skeleton for a landing card. */
export default defineComponent({ name: "LandingCardSkeleton" });
</script>
